import store from "../app/store";
import { getGOpsJobCodes } from "../api/commonConfig/jobCode"
import { getGOpsWorkgroups } from "../api/commonConfig/workgroup"
import { setJobCodeData, setWorkgroupData } from "../slices/commonConfig/commonConfigSlice";

export const loadCommonConfigData = async () => {
  const [jobCodeData, workgroupData] = await Promise.all([getGOpsJobCodes(), getGOpsWorkgroups()]);
  if (jobCodeData && workgroupData) {
    store.dispatch(setJobCodeData(jobCodeData));
    store.dispatch(setWorkgroupData(workgroupData));
  }
}